{
  "nav": {
    "groups": {
      "personal": "Personnel",
      "productivity": "Productivité",
      "pipeline": "Pipeline",
      "firm_wide": "À l'échelle du cabinet"
    },
    "items": {
      "my_contacts": "Mes contacts",
      "contacts": "Contacts",
      "my_companies": "Mes sociétés",
      "companies": "Sociétés",
      "my_lists": "Mes listes",
      "lists": "Listes",
      "my_journey": "Mon parcours",
      "tasks": "Tâches",
      "my_tasks": "Mes tâches",
      "calendar": "Calendrier",
      "my_calendar": "Mon calendrier",
      "workspaces": "Espaces de travail",
      "apps": "Applications",
      "objectives": "Objectifs",
      "my_objectives": "Mes objectifs",
      "stay_in_touch": "Rester en contact",
      "prospecting": "Prospection",
      "my_prospects": "Mes prospects",
      "opportunities": "Opportunités",
      "my_opportunities": "Mes opportunités",
      "key_activities": "Activités clés",
      "all_contacts": "Tous les contacts",
      "all_companies": "Toutes les sociétés",
      "marketing_lists": "Listes marketing",
      "campaigns": "Campagnes",
      "all_prospects": "Tous les prospects",
      "all_opportunities": "Toutes les opportunités",
      "all_objectives": "Tous les objectifs",
      "referrals": "Recommandations",
      "sent_referrals": "Recommandations envoyées",
      "received_referrals": "Recommandations reçues",
      "reports": "Rapports",
      "all_reports": "Tous les rapports"
    },
    "admin": {
      "data_cleaner": "Nettoyeur de données",
      "reporting": "Rapports",
      "user_management": "Gestion des utilisateurs",
      "tag_management": "Gestion des étiquettes",
      "import": "Importer",
      "activity_titles": "Titres d'activité",
      "internal_industries": "Industries internes",
      "forms": "Formulaires",
      "industry_mapper": "Mappeur d'industrie",
      "ems_setup": "Configuration EMS",
      "marketing_contacts": "Contacts marketing"
    },
    "create_menu": {
      "create": "Créer",
      "contact": "Contact",
      "company": "Société",
      "opportunity": "Opportunité",
      "task": "Tâche",
      "nexl_ai": "Nexl IA"
    },
    "tooltips": {
      "notifications": "Notifications",
      "admin": "Administrateur"
    },
    "alt_text": {
      "go_to_dashboard": "aller au tableau de bord",
      "go_to_home": "aller à l'accueil"
    },
    "teams": {
      "project": "Projet"
    }
  },
  "headers": {
    "search_prospects": "Rechercher de nouveaux prospects",
    "nexl_apps": "Applications NEXL",
    "marketing_exclusion_rules": "Règles d'exclusion marketing"
  },
  "settings": {
    "language": "Langue"
  }
}
